import * as ACTION from "./ActionTypes";

export const updateCarrierLookupPrices = (payload) => ({
    type: ACTION.SET_CARRIER_LOOKUP_PRICES,
    payload: payload
});